<template>
  <v-card class="card-content-container">
    <v-card-title class="d-flex justify-center">{{ mode }}</v-card-title>
    <v-form
      @submit.prevent="submitForm"
      ref="form"
      v-model="valid"
      style="max-width: 1500px"
      class="mx-auto px-4"
    >
      <v-alert
        dense
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mr-1 ml-1"
      >
        {{ alertValidate }}
      </v-alert>

      <div v-for="(input, i) in inputsForm" :key="'input_' + i + input.name">
        <v-text-field
          :name="input.name"
          v-model="input.data"
          :type="input.type"
          :label="input.label"
          :rules="input.rules"
          outlined
          dense
        />
      </div>
      <DateWithCheck class="mt-1 mb-6" v-if="showDate && modo !== 'Editar'" />
      <div>
        <v-select
          v-model="selects[0].data"
          v-if="modo !== 'Editar' && selects[0]"
          :name="selects[0].name"
          :items="selects[0].items"
          :item-text="selects[0].itemsText"
          :item-value="selects[0].itemsValue"
          :label="selects[0].label"
          :rules="selects[0].rules"
          :multiple="multiple"
          outlined
          dense
        />
      </div>

      <div v-if="modo === 'Editar'">
        <table-with-search
          :items="editToClocks"
          :title="title"
          :headers="allHeaders"
          :openDialog="openDialogRelation"
          @headersUpdated="updateHeadersConceptos"
          class="mb-5"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div class="d-flex justify-space-between">
        <v-btn class="bt-exit mb-4" @click="cancel">{{
          $tc("editRegistrations.cancel")
        }}</v-btn>
        <v-btn type="submit" class="bt-acept ml-3">
          {{ $tc("editRegistrations.acept") }}</v-btn
        >
      </div>
    </v-form>
    <v-dialog
      v-model="openRelation"
      :max-width="'580px'"
      persistent
      @keydown.esc="reset(false)"
    >
      <Form
        :key="modoConcept"
        :itemsSelect="selectsData"
        @save="save"
        @cancel="reset"
        :maxWidth="'580px'"
        :show="true"
        :mode="modeConcept"
        :showDate="true"
        :showDateFrom="true"
        :showDateTo="true"
        :showCheck="true"
      />
    </v-dialog>
    <DeleteDialogClock
      :showDialog="openDeleteRelation"
      :title="titleDeleteClock"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
      :maxWidth="'300px'"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-card>
</template>
<script>
import DeleteDialogClock from "@/components/Complement/DeleteDialog.vue";
import costCenters from "@/store/centrosDeCosto/costCenters";
import concepts from "@/store/conceptos/concepts";
import date from "@/store/common/date";
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import Form from "@/components/Complement/Form.vue";
import Vue from "vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import moment from "moment";
import conceptToConceptSalary from "@/models/conceptos/conceptToConcepSalary";
import salaryConcepts from "@/store/conceptosDeSueldos/salaryConcepts";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    DateWithCheck,
    Date,
    Form,
    TableWithSearch,
    DeleteDialogClock,
    Snackbar,
  },
  props: {
    items: {
      type: Array,
    },
    maxWidth: String,
    mode: String,
    itemsSelect: Array,
    show: {
      type: Boolean,
      default: false,
    },
    itemsSlider: Array,
    showDate: Boolean,
    showCheck: Boolean,
    multiple: Boolean,
    itemsCheckbox: Array,
  },
  data() {
    return {
      inputsForm: [],
      valid: true,
      error: false,
      alertValidate: "",
      selects: [],
      inputSlider: [],
      checkboxes: [],
      title: "Conceptos",
      titleTable: "ConceptosDeSueldo_y_Relaciones",
      oldItems: {},
      titleDeleteClock: this.$tc("salariesConcepts.toConceptRelation"),
      color: "#82A1D0",
      alert: false,
      textAlert: "",
    };
  },
  async mounted() {
    await concepts.dispatch("getConcepts");
    this.checkboxes = Vue.observable(this.itemsCheckbox);
    this.inputsForm = Vue.observable(this.items);
    this.selects = Vue.observable(this.itemsSelect);
    this.inputSlider = Vue.observable(this.itemsSlider);
    date.commit("setCheckTo", true);
  },
  computed: {
    allHeaders() {
      return configTable.state.colums.conceptos;
    },
    formItems() {
      return this.modoConcept === "Editar" ? this.inputs : [];
    },
    formSelects() {
      return this.modoConcept === "Agregar" ? this.selectsData : [];
    },
    modo() {
      return this.mode === this.$tc("concepts.addConcept")
        ? this.$tc("commons.add")
        : this.$tc("commons.edit");
    },

    modoConcept() {
      return this.modeConcept === this.$tc("concepts.concepts")
        ? this.$tc("commons.add")
        : this.$tc("commons.edit");
    },
    modeConcept: {
      get() {
        return salaryConcepts.state.modeRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    concepts() {
      return concepts.state.concepts;
    },
    filterConcepts() {
      const filter = concepts.state.concepts?.filter(
        (concept) =>
          !salaryConcepts.state.editRelation?.conceptos?.some(
            (emp) => emp.conceptoId === concept.conceptId
          )
      );
      return filter;
    },
    openRelation: {
      get() {
        return salaryConcepts.state.openRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    editToClocks() {
      const conceptos = salaryConcepts.state.editRelation.conceptos;
      const conceptosInstancias = conceptos.map((concepto) =>
        conceptToConceptSalary.fromJson(concepto)
      );
      return conceptosInstancias;
    },
    openDeleteRelation: {
      get() {
        return salaryConcepts.state.openDeleteRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    clocks() {
      return clocks.state.clocks;
    },
    concepts() {
      return concepts.state.concepts;
    },

    selectsData() {
      return [
        {
          name: "conceptId",
          label: this.$tc("concepts.concepts"),
          data: [],
          items: this.filterConcepts,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ];
    },
  },
  methods: {
    async refreshItems() {
      if (salaryConcepts.state.editRelation.csueldoId) {
        await salaryConcepts.dispatch(
          "getSalaryConceptId",
          salaryConcepts.state.editRelation.csueldoId
        );
      }
    },
    updateHeadersConceptos(headers) {
      const updatedColums = { ...configTable.state.colums, conceptos: headers };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.allHeaders;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    openEditForm(item) {
      this.selectsData[0].data = item.conceptoId;
      date.state.dateFrom = moment(item.fecDesde, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      if (item.fecHasta !== null) {
        date.state.dateTo = moment(item.fecHasta, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
        date.state.checkTo = false;
      }
      salaryConcepts.commit("setOpenRelation", true);
    },

    submitForm(e) {
      e.preventDefault();
      this.validation(e.target);
    },

    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset() {
      this.resetDate();
      salaryConcepts.commit("setModeRelation", "");
      salaryConcepts.commit("setOpenRelation", false);
      this.selectsData.forEach((item) => {
        item.data = "";
      });
    },

    save(items) {
      switch (this.typeForm) {
        case "add":
          this.addConceptToSalary(items);
          break;
        case "edit":
          this.editConcepts(items);
          break;
        default:
          break;
      }
    },

    addConceptToSalary(items) {
      let payload = items;
      payload.cSueldoId = salaryConcepts.state.editRelation.csueldoId;
      payload.fecDesde = date.state.dateFrom;
      if (!date.state.checkTo) {
        payload.fecHasta = date.state.dateTo;
      }
      let searchName = this.concepts.find(
        (item) => item.conceptId === Number(payload.conceptId)
      );
      payload.nombre = searchName.name;
      salaryConcepts.commit("setNew", payload);
      salaryConcepts
        .dispatch("addConceptToSalary")
        .then(() => {
          salaryConcepts.commit("setOpenRelation", false);
          this.showAlert(
            this.$tc("salariesConcepts.addConceptToSalarySuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("salariesConcepts.errorConceptToSalary"),
            "#ff8d58"
          );
        });
      this.reset(false);
    },
    sendEdit(updatedItem) {
      costCenters.commit("setEditClock", updatedItem);

      costCenters
        .dispatch("editClock")
        .then(() => {
          costCenters.commit("setOpenRelation", false);
          this.showAlert(this.$tc("costCenter.editClockSuccess"), "#82A1D0");
        })
        .catch((e) => {
          console.error("Error al aplicar los cambios:", e);
          this.showAlert(this.$tc("costCenter.editClockError"), "#ff8d58");
        });

      this.reset(false);
    },

    editConcepts(form) {
      let payload = this.detectChanges(form);

      if (Object.keys(payload).length > 0) {
        payload.fecDesdeOld = this.oldItems.dateStartInput;
        payload.csueldoId = salaryConcepts.state.editRelation.csueldoId;
        payload.conceptoId = Number(form.conceptId);

        let searchName = this.concepts.find(
          (item) => item.conceptId === payload.conceptoId
        );
        payload.nombre = searchName.name;
        payload.itemsForm = form;

        salaryConcepts.commit("setEdit", payload);
        salaryConcepts
          .dispatch("editConceptToSalary")
          .then(() => {
            this.showAlert(
              this.$tc("salariesConcepts.editConceptToSalarySuccess"),
              "#82A1D0"
            );
          })
          .catch((error) => {
            if (error.response && error.response.status === 406) {
              this.showAlert(
                "salariesConcepts.errorConceptToSalary406",
                "#ff8d58"
              );
            } else {
              this.showAlert(
                "salariesConcepts.errorConceptToSalary",
                "#ff8d58"
              );
            }
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },

    detectChanges(newItems) {
      newItems.dateStartInput = date.state.dateFrom;
      newItems.dateEndInput = date.state.dateTo;

      const changes = {};
      const oldItem = this.oldItems;

      if (oldItem) {
        if (
          oldItem.dateStartInput &&
          oldItem.dateStartInput.substring(0, 10) !== newItems.dateStartInput
        ) {
          changes.dateStartInput = newItems.dateStartInput;
        }

        if (
          (oldItem.dateEndInput && oldItem.dateEndInput.substring(0, 10)) !==
          newItems.dateEndInput
        ) {
          changes.dateEndInput = newItems.dateEndInput;
        }
      }

      return changes;
    },

    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();

      this.$emit("save", itemsComplete);
    },
    cancel() {
      this.$refs.form.resetValidation();

      this.$emit("cancel", false);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },

    handleChange(i) {
      console.log(i);
    },
    async openDialogRelation(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          this.selectsData[0].readonly = false;
          await salaryConcepts.commit(
            "setModeRelation",
            this.$tc("concepts.addConcept")
          );
          salaryConcepts.commit("setOpenRelation", true);
          break;
        case "edit":
          this.selectsData[0].readonly = true;
          this.oldItems = item;
          await salaryConcepts.commit(
            "setModeRelation",
            this.$tc("concepts.editConcept")
          );
          await this.openEditForm(item);
          break;
        case "delete":
          salaryConcepts.commit("setOpenDeleteRelation", true);
          this.itemToDelete = item;
          this.itemToDelete.cSueldoId =
            salaryConcepts.state.editRelation.csueldoId;
          break;

        default:
          break;
      }
    },
    deleteItem() {
      salaryConcepts.commit("setItemDelete", this.itemToDelete);
      salaryConcepts
        .dispatch("deleteConceptToSalary")
        .then(() => {
          salaryConcepts.commit("setOpenDeleteRelation", false);
          this.showAlert(
            this.$tc("salariesConcepts.deleteConceptToSalarySuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert("salariesConcepts.errorConceptToSalary", "#ff8d58");
        });
    },

    cancelDelete() {
      this.openDelete = false;
      salaryConcepts.commit("setOpenDeleteRelation", false);
    },
  },
};
</script>

<style scoped>
.slider-input {
  display: flex !important;
  justify-content: center !important;
  align-items: flex-end !important;
}

.slider-container {
  border: 1px solid #959595;
  margin-bottom: 30px;
  height: 110px;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.card-content-container {
  max-width: 1500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
